import '../global';
const fetcher = (() => {
    const base = async (input, init) => fetch(input, init);
    const exported = base;
    Object.defineProperties(exported, {
        Headers: { get: () => Headers },
        Response: { get: () => Response },
        Request: { get: () => Request }
    });
    return exported;
})();
export {
    fetcher as fetch
};
export default fetcher;    //# sourceMappingURL=fetch.js.map
